import form from "./schemas/form";
import validations from "./schemas/validations";
import {useState} from "react";
import axios from "axios";
import {API_URL} from "../../../config";
import { useNavigate } from 'react-router-dom';

const useNewScrape = () => {

    const navigate = useNavigate();

    const {formId, formField} = form;
    const currentValidation = validations;

    const [isLoading, setIsLoading] = useState(false);
    const [urls, setUrls] = useState([]);
    const [scrapeId, setScrapeId] = useState(null);

    const [step, setStep] = useState(0);

    const [retryTime, setRetryTime] = useState(5); // Tiempo inicial de reintento
    const [showRetryMessage, setShowRetryMessage] = useState(false); // Para mostrar el mensaje de reintento

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'secondary',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    const startRetryCountdown = (callback) => {
        setShowRetryMessage(true);
        setRetryTime(5);

        const interval = setInterval(() => {
            setRetryTime((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 5;
                }
                return prev - 1;
            });
        }, 1000);

        setTimeout(() => {
            clearInterval(interval);
            callback();
        }, 5000);
    };

    const handleSubmit = async (values, actions) => {

        try {

            // Enviar datos a API
            const scrapeResponse = await axios.post(
                `${API_URL}/scrape`,
                {...values}
            );

            actions.resetForm();
            setStep(1);
            setShowRetryMessage(true);

            const {scrape_id} = scrapeResponse.data.data;
            setScrapeId(scrape_id);

            await pollScrapeStatus(scrape_id);

        } catch (error) {

            setSnackbarConfig({
                message: error?.response?.data?.message || 'Ocurrió un error al iniciar el análisis de documentos.',
                icon: 'cancel',
                title: 'Propiedades',
                color: 'warning'
            });

            setShow(true);

        } finally {
            actions.setSubmitting(false);

        }
    };

    const pollScrapeStatus = async (id) => {
        try {
            const scrapeResponse = await axios.get(`${API_URL}/scrapes/${id}`);
            const scrapeData = scrapeResponse.data.data;

            if (scrapeData.status === 'completed') {
                setShowRetryMessage(false);
                setUrls(scrapeData.files || []);

                if (scrapeData.vectorStore && scrapeData.thread) {
                    await checkVectorStoreStatus(scrapeData.vectorStore, scrapeData.thread);
                } else {
                    setSnackbarConfig({
                        message: 'El procesamiento finalizó pero no se recibieron los identificadores necesarios para continuar.',
                        icon: 'warning',
                        title: 'Propiedades',
                        color: 'warning'
                    });
                    setShow(true);
                }
            } else if (scrapeData.status === 'failed') {
                setShowRetryMessage(false);
                setSnackbarConfig({
                    message: scrapeData.message || 'El análisis de documentos falló.',
                    icon: 'cancel',
                    title: 'Propiedades',
                    color: 'warning'
                });
                setShow(true);
            } else {
                startRetryCountdown(() => pollScrapeStatus(id));
            }
        } catch (error) {
            setShowRetryMessage(false);
            setSnackbarConfig({
                message: error?.response?.data?.message || 'Error al consultar el estatus del análisis.',
                icon: 'cancel',
                title: 'Propiedades',
                color: 'warning'
            });
            setShow(true);
        }
    }

    const checkVectorStoreStatus = async (vectorStoreId, threadId) => {

        try {

            // Enviar datos a API
            const vectorStoreResponse = await axios.get(
                `${API_URL}/vector_stores/${vectorStoreId}`
            );

            // Checar estatus del vector store
            if(vectorStoreResponse.data.data.status !== 'completed'){

                startRetryCountdown(() => checkVectorStoreStatus(vectorStoreId, threadId));

            } else {

                // Navegar a la nueva URL
                setShowRetryMessage(false);
                navigate(`/hilos/${threadId}`);
            }

        } catch (error) {

            setSnackbarConfig({
                message: error?.response?.data?.message || 'Error al procesar los archivos.',
                icon: 'cancel',
                title: 'Procesamiento de Archivos',
                color: 'warning'
            });

            setShow(true);

        }
    };

    return {
        step,
        urls,
        scrapeId,
        currentValidation,
        formId,
        formField,
        isLoading,
        showRetryMessage,
        retryTime,
        show,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewScrape;
